var _module_exports ="<div ng-class=\"{'dim-overlay': showDimOverlay}\"></div>\n\n<div ng-transclude class=\"highlight-content\"></div>\n";;
var path = '/app/shared/components/directives/highlightOverlay.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;